<table class="subwindow" [cdkDragConstrainPosition]="constrainPosition" plessTitleWindowSub cdkDrag [windowMovable]="false" [windowResizable]="false">
  <tr class="subwindow-title" cdkDragHandle>
    <th class="window-title-name">ポイント交換商品プロモーション設定</th>
  </tr>
  <tr class="subwindow-body">
    <td>
      <div class="contents-area" (dragstart)="onDragstartBody($event)">
        <div class="element-column">
          <div class="column-list">
            <label class="list-input-title">アイテムコード</label>
            <div class="list-input-content">
              <select #cmb_ItemCode id="cmb_ItemCode" class="combo-box-required" forcedEnabledMode="None" tabindex="0"
                [style.width.px]="175" [(ngModel)]="kymw0909Model.selectedItemCode" (change)="eventItemCode_CHANGEHandler()" 
                [disabled]="isReadOnlyMode() || isDetailMode()">
                <ng-template ngFor let-item [ngForOf]="kymw0909Model.itemCodeList">
                  <option value="{{item.ItemCode}}">{{item.ItemCode}}</option>
                </ng-template>
              </select>
            </div>
          </div>
          <div class="block-row">
            <div class="column-list">
              <label class="list-input-title">注文コード割当コード</label>
              <div class="list-input-content">
                <select class="combo-box-required" id="cmb_PointExchangeOrderNumQuotaCode"
                  #cmb_PointExchangeOrderNumQuotaCode [tabindex]="0" [style.width.rem]="17"
                  [(ngModel)]="this.kymw0909Model.pointExchangeOrderNumQuotaCode" [disabled]="isReadOnlyMode()">
                  <ng-template ngFor let-item [ngForOf]="this.kymw0909Model.pointExchangeOrderNumQuotaCodeList">
                    <option value="{{item.OrderNumQuotaCode}}">{{item.OrderNumQuotaCodeName}}</option>
                  </ng-template>
                </select>
              </div>
            </div>
            <div class="column-list">
              <label class="list-input-title" style="width: 12rem;">ポイント交換注文コード</label>
              <div class="list-input-content">
                <input type="text" #txti_PointExchangeOrderNum id="txti_PointExchangeOrderNum"
                  plessInputTextSub [tabindex]="0" readonly
                  [(ngModel)]="this.kymw0909Model.pointExchangeOrderNum" [style.width.rem]="6"/>
              </div>
            </div>
          </div>
          <div class="column-list">
            <label class="list-input-title">専用商品名</label>
            <div class="list-input-content">
              <app-not-null-text-input-coop-deli #txti_PointExchangeGoodsName id="txti_PointExchangeGoodsName" [subid]="'txti_PointExchangeGoodsName'"
                [fullOnly]="true" [restrict]="'[ -￮]'" [maxChars]="15" [forcedEnabledMode]="'none'" [required]="true"
                [tabindex]="0" [displayCountField]="false" [(ngModel)]="this.kymw0909Model.pointExchangeGoodsName"
                [style.width.rem]="17"  [disabled]="isReadOnlyMode()">
              </app-not-null-text-input-coop-deli>
            </div>
            <label class="list-input-title">専用商品名(カナ)</label>
            <div class="list-input-content">
              <app-text-input #txti_PointExchangeGoodsNameKana id="txti_PointExchangeGoodsNameKana" [subid]="'txti_PointExchangeGoodsNameKana'"
                [halfOnly]="true" [restrict]="'[ -￮]'" [maxChars]="15" [forcedEnabledMode]="'none'"
                [tabindex]="0" [displayCountField]="false" [(ngModel)]="this.kymw0909Model.pointExchangeGoodsNameKana"
                [style.width.rem]="17" (input)="eventPointExchangeGoodsNameKana_deleteCommaHandler()"
                (compositionstart)="onCompStart()" (compositionend)="onCompDeleteCommaEnd($event)"
                [disabled]="isReadOnlyMode()" [toUpperCase]="true">
              </app-text-input>
            </div>
            <label class="list-input-title">専用規格名</label>
            <div class="list-input-content">
              <app-text-input-coop-deli #txti_PointExchangeGuideName id="txti_PointExchangeGuideName" [subid]="'txti_PointExchangeGuideName'"
                [fullOnly]="true" [restrict]="'[ -￮]'" [maxChars]="10" [forcedEnabledMode]="'none'"
                [tabindex]="0" [displayCountField]="false" [(ngModel)]="this.kymw0909Model.pointExchangeGuideName"
                [style.width.rem]="12"  [disabled]="isReadOnlyMode()">
              </app-text-input-coop-deli>
            </div>
            <label class="list-input-title">専用規格名(カナ)</label>
            <div class="list-input-content">
              <app-text-input #txti_PointExchangeGuideNameKana id="txti_PointExchangeGuideNameKana" [subid]="'txti_PointExchangeGuideNameKana'"
                [halfOnly]="true" [restrict]="'[ -￮]'" [maxChars]="10" [forcedEnabledMode]="'none'"
                [tabindex]="0" [displayCountField]="false" [(ngModel)]="this.kymw0909Model.pointExchangeGuideNameKana"
                [style.width.rem]="12" (input)="eventPointExchangeGuideNameKana_deleteCommaHandler()"
                (compositionstart)="onCompStart()" (compositionend)="onCompDeleteCommaEnd($event)"
                [disabled]="isReadOnlyMode()"  [toUpperCase]="true">
              </app-text-input>
            </div>
            <label class="list-input-title">ポイント不足エラー区分</label>
            <div class="list-input-content">
              <app-code-combo-box #cmb_ShortOfPointDiv [required]="true" [codeDiv]="'ctp354'"
                [labelField]="'codeValueName'" id="cmb_ShortOfPointDiv" [subid]="'cmb_ShortOfPointDiv'"
                [forcedEnabledMode]="'none'" [disabled]="isReadOnlyMode()"
                [tabindex]="0" [style.width.rem]="17" [(ngModel)]="this.kymw0909Model.shortOfPointDiv">
              </app-code-combo-box>
            </div>
            <label class="list-input-title">ECのみ掲載</label>
            <div class="list-input-content">
              <app-checkbox-label #chk_EcOnlyFlg [label]="''" id="chk_EcOnlyFlg"
                [subid]="'chk_EcOnlyFlg'" [tabindex]="0" [(ngModel)]="this.kymw0909Model.ecOnlyFlg"
                [disabled]="isReadOnlyMode()">
              </app-checkbox-label>
            </div>
            <label class="list-input-title">ポイント購入時割引率一括設定</label>
            <div class="list-input-content">
              <app-code-combo-box #cmb_PointRateAllSetting [codeDiv]="'ctp380'"
                [labelField]="'CodeName'" id="cmb_PointRateAllSetting" [subid]="'cmb_PointRateAllSetting'"
                [tabindex]="0" [style.width.rem]="17" [(ngModel)]="this.kymw0909Model.pointRateAllSetting"
                [disabled]="isReadOnlyMode()">
              </app-code-combo-box>
              <button #btn_DiscountRateSetting id="btn_DiscountRateSetting"
                class="btn-secondary" [tabindex]="0" [disabled]="isReadOnlyMode()"
                (click)="eventDiscountRateSetting_CLICKHandler(this.kymw0909Model.pointRateAllSetting)">
                割引率一括設定
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="element-column">
        <wj-flex-grid #dtg_CoopPointRateList [style.width.px]="735" [style.height.px]="255"
          id="dtg_CoopPointRateList" [tabindex]="0" [itemsSource]="this.kymw0909Model.coopPointRateList"
          [selectionMode]="'Row'" [headersVisibility]="'Column'" [allowDragging]="'None'"
          sortableColumns="false" rowHeight="50" editable="true"[allowSorting]="false" 
          [isReadOnly]="true" [allowResizing]="'Columns'">
          <wj-flex-grid-column [minWidth]="5" [width]="40" [binding]="''" [header]="' '" [align]="'center'">
            <!-- 一括チェックボックス -->
            <ng-template wjFlexGridCellTemplate [cellType]="'ColumnHeader'" let-cell="cell">
              <div class="all-target_list-checkbox">
                <input type="checkbox" id="coop_point_rate_list_all_check" #coop_point_rate_list_all_check [tabindex]="0"
                  (change)="eventCoopPointRateListAll_CLICKHandler()"
                  [(ngModel)]="this.kymw0909Model.planGoodsCoopPointRateEnableFlgAll"
                  class="headear-checkbox all-target_list-checkbox" [disabled]="isReadOnlyMode()"/>
              </div>
            </ng-template>
            <!-- 単体チェックボックス -->
            <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
              <div>
                <input type="checkbox" [tabindex]="-1" (mouseup)="$event.stopPropagation()" 
                  [(ngModel)]="cell.item.PlanGoodsCoopPointRateEnableFlg" id="coop_point_rate_list_check_{{cell.row.index}}"
                  (change)="eventCoopPointRateListChk_CLICKHandler(cell.item)"
                  [disabled]="isReadOnlyMode() || cell.item.DisabledFlg"/>
              </div>
            </ng-template>
          </wj-flex-grid-column>
          <wj-flex-grid-column [minWidth]="5" [width]="85" [binding]="'CoopName'" [header]="'会員生協'">
          </wj-flex-grid-column>
          <wj-flex-grid-column [minWidth]="5" [width]="130" [binding]="'ThisTimeSupplyPrice'" [header]="'供給単価'" [align]="'right'">
          </wj-flex-grid-column>
          <wj-flex-grid-column [minWidth]="5" [width]="160" [binding]="'PointRate'" [header]="'ポイント購入時割引率'">
            <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
              <app-code-combo-box #cmb_PointRate [codeDiv]="'ctp380'"
                [labelField]="'CodeName'" id="cmb_PointRate" [subid]="'cmb_PointRate'"
                [forcedEnabledMode]="'none'" [disabled]="!cell.item.PlanGoodsCoopPointRateEnableFlg || isReadOnlyMode()"
                [tabindex]="0" [style.width.%]="'100'" [(ngModel)]="cell.item.PointRate"
                (change)="eventPointRate_CLICKHandler(cell.item.PointRate, cell.row.index)">
              </app-code-combo-box>
            </ng-template>
          </wj-flex-grid-column>
          <wj-flex-grid-column [minWidth]="5" [width]="160" [binding]="'ExchangePointWithoutTax'" [header]="'交換ポイント(税抜)'" [align]="'right'">
          </wj-flex-grid-column>
          <wj-flex-grid-column [minWidth]="5" [width]="140" [binding]="'ExchangePoint'" [header]="'交換ポイント'" [align]="'right'">
          </wj-flex-grid-column>
        </wj-flex-grid>
      </div>
    </td>
  </tr>

  <tfoot cdkDragHandle>
    <tr>
      <td>
        <div class="footer-buttons">
          <button id="btn_Set" forcedEnabledMode="" class="btn-primary" (click)="eventSet_CLICKHandler()" [disabled]="isReadOnlyMode()"
            [tabindex]="0">設定</button>
        </div>
        <div class="window-title-close">
          <button [tabindex]="0" (click)="eventClose_CLICKHandler()"></button>
        </div>
      </td>
    </tr>
  </tfoot>
</table>
